export default {
  duration: {
    lessThanMinute: 'Less than a minute',
    unknown: 'Unknown duration',
  },
  relative: {
    justNow: 'Just now',
    ago: '{duration} ago',
    in: 'in {duration}',
  },
  formats: {
    long: 'PP', // e.g., Apr 29, 2021
    short: 'P', // e.g., 04/29/2021
    longWithTime: 'PP, p', // e.g., Apr 29, 2021, 9:30 AM
    shortWithTime: 'P, p', // e.g., 04/29/2021, 9:30 AM
    longWithDay: 'EEEE, PP', // e.g., Monday, Apr 29, 2021
    longWithTimeAndDay: 'EEEE, PP, p', // e.g., Monday, Apr 29, 2021, 9:30 AM
  },
};
